import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthModal } from '@features/common/protected-auth-route/model.ts';
import { useProgramModalBuyState } from '@features/programs/buy-program/model.ts';
import { useUser, useWindowWidth } from '@shared/hooks';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import * as st from './Text.module.scss';

type Props = {
  description: string;
  about?: string;
  onRedirect?: () => void;
  mode: string;
  isNeedPay: boolean;
  programId?: number;
  isCurrentVideoAvailableBySchedule?: boolean;
  onCurrentVideoNotAvailableClick?: () => void;
};

const Text: React.FC<Props> = ({
  description,
  programId,
  about,
  onRedirect,
  isNeedPay,
  mode,
  isCurrentVideoAvailableBySchedule,
  onCurrentVideoNotAvailableClick,
}) => {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth <= 768;
  const navigate = useNavigate();
  const { code } = useParams();
  const { isAuth } = useUser();
  const { openAuth } = useAuthModal();
  const { doOpenModal } = useProgramModalBuyState(programId);

  const onShowMoreButtonClick = () => {
    if (!isCurrentVideoAvailableBySchedule) {
      onCurrentVideoNotAvailableClick?.();
    } else {
      onRedirect && onRedirect();
      if (mode === 'comment' || isAuth) {
        if (mode === 'comment' || !isNeedPay) {
          navigate(`/programs/${code}/program/description/`, {
            state: { description, about, mode },
          });
          return;
        } else {
          doOpenModal();
        }
      } else {
        openAuth();
      }
    }
  };

  return (
    <section className={st.section}>
      <DescriptionViewer
        description={description}
        isAlwaysFull={isMobile}
        className={isMobile ? undefined : st.text}
        isSmallViewer={!isMobile}
        onShowMore={onShowMoreButtonClick}
      />
    </section>
  );
};

export default Text;
